module.exports = __webpack_public_path__ + "static/media/demoChannelBanner.fb8d49e3.jpg";